"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhitelistButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const whitelist_json_1 = __importDefault(require("@framework/abis/json/ERC20Whitelist/whitelist.json"));
const dialogs_1 = require("../../../dialogs");
const utils_1 = require("../../../utils");
const validation_1 = require("../../../dialogs/account/validation");
const WhitelistButton = (props) => {
    const { className, contract, contract: { address, contractFeatures, accessControls }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: address,
            abi: whitelist_json_1.default,
            functionName: "whitelist",
            args: [values.account],
        });
    });
    const handleWhitelistConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    const handleWhitelist = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ACCOUNT, contract, {
            initialValues: {
                account: "",
            },
            validationSchema: validation_1.accountDialogValidationSchema,
            message: "dialogs.whitelist",
            testId: "AccessListWhitelistForm",
            onExternalConfirm: handleWhitelistConfirmed,
        });
    };
    if (!contractFeatures.includes(types_1.ContractFeatures.WHITELIST)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleWhitelist, icon: icons_material_1.CheckCircle, message: "form.buttons.whitelist", className: className, dataTestId: "WhitelistButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }));
};
exports.WhitelistButton = WhitelistButton;
//# sourceMappingURL=index.js.map